import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Paper,
  TextField,
  Typography,
} from '@mui/material';

import { useAuth } from '../../context/AuthContext';
import { theme } from '../../theme';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setLoading(true);
      const userData = await login({ email, password }, 'professional');

      if (userData?.role === 'superadmin' || userData?.role === 'admin') {
        navigate('/superadmin');
      } else if (userData?.role === 'professional_employe') {
        navigate('/pro/employe/dashboard');
      } else {
        navigate('/pro');
      }
    } catch (err) {
      setError(err?.data?.detail || err?.response?.data?.detail || 'Échec de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: theme.colors.background.secondary, py: 8 }}>
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            border: `1px solid ${theme.colors.border.light}`,
            p: { xs: 2.5, md: 4 },
            backgroundColor: theme.colors.background.primary,
          }}
        >
          <Typography sx={{ fontWeight: 900, fontSize: '1.6rem', color: theme.colors.text.primary, mb: 0.5 }}>
            Connexion
          </Typography>
          <Typography sx={{ color: theme.colors.text.secondary, mb: 3 }}>
            Accès Pro / SuperAdmin
          </Typography>

          {!!error && <Typography sx={{ color: theme.colors.error[600], fontWeight: 700, mb: 2 }}>{error}</Typography>}

          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              autoComplete="email"
            />
            <TextField
              label="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              fullWidth
              autoComplete="current-password"
            />

            <Button
              variant="contained"
              type="submit"
              disabled={loading}
              sx={{ fontWeight: 900, mt: 1, py: 1.2 }}
            >
              {loading ? <CircularProgress size={22} /> : 'Se connecter'}
            </Button>

            <Button
              variant="outlined"
              onClick={() => navigate('/?bypass=true')}
              sx={{ fontWeight: 900 }}
            >
              Retour au site
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default LoginPage;
